<template>
  <div
    class="home-quick-nav"
    :style="{
      border: isLayoutSet ? '1px dashed #2587FF' : '1px solid #d9d9d9',
    }"
  >
    <div class="title" @click="quickNavHidden = !quickNavHidden">
      <div class="icon eicon eicon-jichugongneng"></div>
      <span>基础功能快捷导航</span>
      <span>按顺序完成</span>
      <span>以下环节操作，即可在平台上开展相关业务</span>
      <img
        :class="{ rotate: quickNavHidden }"
        src="@/assets/img/home/down-arrow.png"
        alt=""
      />
    </div>
    <div :class="{ quickNavHidden: quickNavHidden }" class="hidden-content">
      <div class="tab-extra">
        <span></span>
        <span>必要设置环节</span>
        <span></span>
        <span>可选择环节</span>
      </div>
      <el-tabs v-model="quickNavActive" class="tabs-area">
        <el-tab-pane label="平台销售业务" name="0">
          <div class="steps">
            <div>
              <div>
                <svg
                  width="7"
                  height="11"
                  viewBox="0 0 7 11"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M4.61832 10.92H1.19832L2.33232 2.856L0.92832 3.054L1.19832 1.182L6.07632 0.497999L4.61832 10.92Z"
                    fill="#F5F5F5"
                  />
                </svg>
              </div>
            </div>
            <div>
              <div>
                <svg
                  width="12"
                  height="11"
                  viewBox="0 0 12 11"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.11099 2.37H4.67299L4.51099 3.738H1.09099L1.52299 0.659999H11.765L10.901 6.816H3.71899L3.39499 9.21H9.89299L10.667 8.526L10.325 10.92H1.30699C0.958992 10.92 0.682992 10.806 0.478992 10.578C0.274992 10.338 0.196992 10.044 0.244992 9.696L0.892992 5.106H7.71499L8.11099 2.37Z"
                    fill="#F5F5F5"
                  />
                </svg>
              </div>
            </div>
            <div>
              <div>
                <svg
                  width="13"
                  height="11"
                  viewBox="0 0 13 11"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.8043 6.474H1.6483L1.8823 4.764H8.0383L8.3803 2.37H1.5403L1.7743 0.678H12.0343L10.7563 9.696C10.7083 10.044 10.5463 10.338 10.2703 10.578C10.0063 10.806 9.7063 10.92 9.3703 10.92H0.334297L0.586297 9.21H7.4083L7.8043 6.474Z"
                    fill="#F5F5F5"
                  />
                </svg>
              </div>
            </div>
            <div>
              <div>
                <svg
                  width="13"
                  height="11"
                  viewBox="0 0 13 11"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M2.57213 0.678H6.49613L4.62413 7.158H7.28813L8.11613 1.344L7.52213 0.678H11.6261L10.7081 7.158H12.0761L11.8421 8.868H10.4741L10.1861 10.92H6.76613L7.05413 8.868H0.916133L1.15013 7.158L2.96813 1.11L2.57213 0.678Z"
                    fill="#F5F5F5"
                  />
                </svg>
              </div>
            </div>
          </div>
          <div class="steps-content">
            <div v-for="(item, index) in saleList" :key="index">
              <div
                v-for="item2 in item"
                :key="item2.text"
                :class="[item2.extraClass || '', 'steps-content-item']"
                @click="navTo(item2)"
              >
                <div>{{ item2.text }}</div>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="平台采购业务" name="1">
          <div class="purchase-steps-content">
            <div>
              <div>配置采购权限</div>
              <div class="steps-content-item">
                <div>维护组织架构</div>
              </div>
              <div class="steps-content-item">
                <div>维护角色权限</div>
              </div>
              <div class="steps-content-item">
                <div>维护企业员工</div>
              </div>
            </div>
            <div>
              <div>配置采购信息</div>
              <div>
                <div class="steps-content-item">
                  <div>维护地址信息</div>
                </div>
                <div class="steps-content-item">
                  <div>维护发票信息</div>
                </div>
              </div>
              <div>
                <div class="steps-content-item plain">
                  <div>开通在线支付</div>
                </div>
                <div class="steps-content-item plain">
                  <div>设置审批流程</div>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    isLayoutSet: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      quickNavActive: '0',
      quickNavHidden: false,
      saleList: [
        [
          {
            text: '收款账号维护',
            extraClass: 'plain',
            url: '',
          },
          {
            text: '交易参数设置',
            extraClass: '',
            url: '',
          },
        ],
        [
          {
            text: '产品目录申请',
            url: '',
          },
          {
            text: '查看目录审核进度',
            url: '',
          },
          {
            text: '申请成功',
            extraClass: 'disabled',
            url: '',
          },
        ],
        [
          {
            text: '外销商品发布',
            url: '',
          },
          {
            text: '外销商品维护',
            url: '',
          },
          {
            text: '规格属性申请',
            extraClass: 'plain',
            url: '',
          },
          {
            text: '销售区域管理',
            url: '',
          },
        ],
        [
          {
            text: '订单确认',
            url: '',
          },
          {
            text: '订单发货',
            url: '',
          },
          {
            text: '开票管理',
            url: '',
          },
          {
            text: '售后管理',
            url: '',
          },
        ],
      ],
    };
  },
  computed: {},
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
@import '@/assets/css/theme.scss';
.home-quick-nav {
  margin-top: 20px;
  background: #ffffff;
  position: relative;
  // box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  overflow: hidden;
  .title {
    display: flex;
    align-items: center;
    height: 44px;
    padding: 0 20px;
    font-size: 12px;
    color: #999;
    background: #f5f5f5;
    border-bottom: 1px solid #d9d9d9;
    .icon {
      font-size: 18px;
      margin-right: 10px;
      color: #333;
    }
  }
  .hidden-content {
    padding: 20px;
    ::v-deep .el-tabs--card {
      & > .el-tabs__header {
        .el-tabs__nav {
          border: none;
        }
        .el-tabs__item {
          border: 1px solid #d9d9d9;
          &:last-child {
            border-left: 0;
          }
        }
        .el-tabs__item.is-active {
          background: #f4f7ff;
          position: relative;
          color: #0064c8;
          &:first-child {
            border-left: 0;
            border-bottom: 0;
          }
          &:last-child {
            border-right: 0;
            border-bottom: 0;
          }
          &::before {
            content: '';
            display: block;
            position: absolute;
            top: -1px;
            left: -1px;
            width: 126px;
            border-top: 2px solid #0064c8;
          }
        }
      }
    }
  }

  .quickNavHidden {
    margin-top: -319px;

    .tab-extra {
      margin-top: -319px;
    }
  }

  > div:nth-child(2) {
    transition: margin-top 0.3s linear;
    margin-bottom: 10px;
  }

  > div:nth-child(1) {
    position: relative;
    line-height: 20px;
    cursor: pointer;
    z-index: 3;

    > span:nth-child(1) {
      margin-right: 20px;
      font-size: 14px;
      color: $c3;
    }

    > span:nth-child(2) {
      font-size: 14px;
      color: #333;
      font-weight: bold;
      margin-right: 1px;
    }

    > span:nth-child(3) {
      font-size: 12px;
      color: #333;
      margin-left: 10px;
    }

    img {
      position: absolute;
      top: 50%;
      margin-top: -4px;
      right: 20px;

      &.rotate {
        transform: rotate(180deg);
      }
    }
  }

  .tab-extra {
    position: absolute;
    top: 70px;
    right: 20px;
    width: 220px;
    height: 12px;
    line-height: 12px;
    text-align: right;
    transition: margin-top 0.3s linear;

    > span {
      display: inline-block;
      font-size: 12px;
      vertical-align: middle;
      color: $c9;
    }

    > span:nth-child(1),
    > span:nth-child(3) {
      width: 12px;
      height: 12px;
      margin-right: 10px;
    }

    > span:nth-child(1) {
      border: 1px solid $main-col;
    }

    > span:nth-child(3) {
      margin-left: 20px;
      border: 1px dashed $main-col;
    }
  }

  .steps {
    height: 40px;
    position: relative;
    background: url('~@/assets/img/home/dashed.png') repeat left center;
    display: flex;

    > div {
      text-align: center;
      flex: 1;
      margin-right: 20px;
      position: relative;
      padding-top: 10px;

      &:last-child {
        margin-right: 0;
      }

      &:before {
        width: 9px;
        height: 12px;
        position: absolute;
        left: 49px;
        top: 14px;
        content: ' ';
        background-image: url('~@/assets/img/home/gray-arrow.png');
        background-size: 9px 12px;
      }

      &:after {
        width: 9px;
        height: 12px;
        position: absolute;
        right: 49px;
        top: 14px;
        content: ' ';
        background-image: url('~@/assets/img/home/gray-arrow.png');
        background-size: 9px 12px;
      }

      > div {
        display: inline-block;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        color: #ffffff;
        background: $main-col;
        text-align: center;

        > svg {
          margin-top: 4px;
          vertical-align: top;
        }
      }
    }
  }

  .steps-content {
    width: 100%;
    height: 172px;
    display: flex;

    > div {
      height: 100%;
      background: #f4f7ff;
      flex: 1;
      margin-right: 20px;
      padding-top: 10px;

      &:last-child {
        margin-right: 0;
      }
    }
  }

  .steps-content-item {
    text-align: center;
    margin: 0 auto 10px;
    width: 130px;
    height: 30px;
    line-height: 28px;
    border: 1px solid rgba(37, 135, 255, 0.59);
    transform: skewX(-15deg);
    position: relative;
    font-size: 14px;
    color: $main-col;
    background: #ffffff;

    &:hover {
      background: $main-col;
      color: #ffffff;
    }

    &.disabled {
      cursor: none;
      color: $c9;
      border: 1px solid #d9d9d9;

      &:hover {
        line-height: 28px;
        cursor: auto;
        color: $c9;
        background: transparent;
        border: 1px solid #d9d9d9;
      }
    }

    &.plain {
      line-height: 26px;
      border: 2px dashed $main-col;
    }

    > div {
      width: 100%;
      height: 100%;
      transform: skewX(15deg);

      &:before {
        width: 2px;
        height: 7px;
        content: ' ';
        position: absolute;
        bottom: -7px;
        left: 50%;
        margin-left: -1px;
        background: linear-gradient(
          to bottom,
          transparent 0%,
          transparent 14%,
          $main-col 14%,
          $main-col 42%,
          transparent 42%,
          transparent 70%,
          $main-col 70%,
          $main-col 100%
        );
      }

      &:after {
        content: ' ';
        position: absolute;
        bottom: -11px;
        left: 50%;
        margin-left: -4px;
        border-top: 4px solid $main-col;
        border-left: 4px solid transparent;
        border-right: 4px solid transparent;
      }
    }

    &:last-child {
      > div {
        &:after,
        &:before {
          content: none;
        }
      }
    }
  }

  .purchase-steps-content {
    display: flex;
    padding-top: 20px;

    > div {
      flex: 1;
      background: #f4f7ff;
      margin-right: 20px;
      padding-top: 20px;
      height: 192px;

      > div:nth-child(1) {
        text-align: center;
        line-height: 1;
        font-size: 14px;
        margin-bottom: 16px;
      }

      .steps-content-item {
        margin-bottom: 18px;

        > div {
          &:before {
            height: 14px;
            bottom: -14px;
          }

          &:after {
            bottom: -19px;
          }
        }
      }

      &:last-child {
        margin-right: 0;
      }
    }

    > div:nth-child(2) {
      > div:nth-child(2),
      > div:nth-child(3) {
        margin: 0 auto;
        width: 284px;
        display: flex;
        justify-content: space-between;
      }

      > div:nth-child(2) {
        margin-top: 32px;
        margin-bottom: 2px;
      }

      .steps-content-item {
        > div {
          &:after,
          &:before {
            content: none;
          }
        }
      }
    }
  }
}
</style>
